import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.items,"label":_vm.label,"outlined":_vm.outlined,"dense":_vm.dense,"item-text":"name","item-value":"id","hide-details":_vm.hideDetails,"clearable":_vm.clearable,"loading":_vm.loading,"rules":_vm.rules,"return-object":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }